import Posthog from 'posthog-js'

import { envConfig } from '../lib/env-config'
import type { IAnalyticsProperties, IAnalyticsWorkspace } from '../types/analytics'

export const initializePosthog = () => {
  // Only initialize in browser environment
  if (typeof window === 'undefined') return

  const apiKey = envConfig.analyticsKey
  if (!apiKey) {
    console.warn('Analytics API key not found')
    return
  }

  Posthog.init(apiKey, {
    api_host: 'https://app.posthog.com',
    autocapture: false,
    disable_session_recording: true,
    loaded: (PosthogInstance) => {
      PosthogInstance.onFeatureFlags(() => {
        if (PosthogInstance.isFeatureEnabled('record-na')) {
          PosthogInstance.startSessionRecording()
        }
      })
    }
  })
}

export const identify = (userId: string, properties?: Record<string, string>): void => {
  if (typeof window === 'undefined') return
  Posthog.identify(userId, properties)
}

export const captureEvent = (eventName: string, properties?: IAnalyticsProperties): void => {
  if (typeof window === 'undefined') return
  Posthog.capture(eventName, properties)
}

export const capturePageview = (page: string): void => {
  if (typeof window === 'undefined') return
  Posthog.capture('$pageview', { page })
}

export const identifyWorkspace = (workspace: IAnalyticsWorkspace): void => {
  if (typeof window === 'undefined') return
  Posthog.group('workspace', workspace.id, {
    displayName: workspace.displayName,
    isVerified: workspace.isVerified,
    name: workspace.workspacename,
    workspaceID: workspace.id
  })
}

export const isFeatureEnabled = (flag: string): boolean => {
  if (typeof window === 'undefined') return false
  let enabled = false
  Posthog.onFeatureFlags(() => {
    enabled = Posthog.isFeatureEnabled(flag) ?? false
  })
  return enabled
}

export const setUserProperty = (property: string | IAnalyticsProperties, value?: string): void => {
  if (typeof window === 'undefined') return
  Posthog.people.set(property, value)
}

export const reset = (): void => {
  if (typeof window === 'undefined') return
  Posthog.reset(true)
}
